/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Meta_PageInputs */

const cs_integrations_meta_page = /** @type {(inputs: Integrations_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook stránka`)
};

const en_integrations_meta_page = /** @type {(inputs: Integrations_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook Page`)
};

/**
* | output |
* | --- |
* | "Facebook Page" |
*
* @param {Integrations_Meta_PageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_meta_page = /** @type {((inputs?: Integrations_Meta_PageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Meta_PageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_meta_page(inputs)
	return cs_integrations_meta_page(inputs)
});